import { Link } from "react-router-dom";
import Logo from "@/components/feature/Logo";
import { SIGNUP_URL, WALKTHROUGH_URL } from "@/pages/products/data";
import { track } from "@/lib/analytics";

export default function ProductsHeader() {
  return (
    <header className="sticky top-0 left-0 right-0 z-50 bg-background-50/85 backdrop-blur-md border-b border-background-300/25">
      <nav className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <Logo imgClassName="h-7 md:h-8" />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className="text-sm font-medium text-foreground-800 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </Link>
            <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
              Products
            </span>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={WALKTHROUGH_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("book_demo_clicked", { location: "products_header_secondary" })}
              className="hidden sm:inline-flex items-center gap-2 rounded-md border border-background-300/60 text-foreground-900 text-sm font-semibold px-4 py-2.5 hover:bg-background-100/70 transition-colors cursor-pointer whitespace-nowrap"
            >
              Book a Demo
            </a>
            <a
              href={SIGNUP_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("try_joble_clicked", { location: "products_header_primary" })}
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold px-4 md:px-5 py-2.5 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Try Joble Now
              <i className="ri-arrow-right-line" aria-hidden></i>
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}